import { CircleAlert, RotateCw } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '../lib/cn';
import { Button } from './button';

export interface ErrorStateProps {
  title?: ReactNode;
  message: ReactNode;
  onRetry?: () => void;
  className?: string;
}

/** Error de carga de una sección, con reintento. */
export function ErrorState({
  title = 'No se pudo cargar',
  message,
  onRetry,
  className,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-3 rounded-xl border border-destructive/30 bg-destructive/5 p-5',
        className,
      )}
    >
      <span
        aria-hidden
        className="flex size-9 shrink-0 items-center justify-center rounded-full bg-destructive/10 text-destructive ring-1 ring-destructive/20 ring-inset"
      >
        <CircleAlert className="size-[1.05rem]" />
      </span>
      <div className="flex min-w-0 flex-col items-start gap-1.5">
        <p className="text-sm font-semibold text-destructive">{title}</p>
        <p className="text-sm text-muted-foreground">{message}</p>
        {onRetry ? (
          <Button size="sm" variant="outline" onClick={onRetry} className="mt-1">
            <RotateCw /> Reintentar
          </Button>
        ) : null}
      </div>
    </div>
  );
}
